<template>
    <v-card class="gs-post-card" :class="$vuetify.breakpoint.name">
        <v-img
            :src="post.thumbnail_base_64"
            @click="goToPost(post.link)"
        >
        </v-img>
        <v-card-text
                @click="goToPost(post.link)"
        >
            <div class="gs-post-data">
                <div class="categories">
                    <ul>
                        <li v-for="category in post.categories"
                            :key="category.id"
                            class="gs-category-li"
                        >
                            {{ category.name }}
                        </li>
                    </ul>

                </div>
                <div class="gs-post-title" v-text="post.title"></div>
                <div class="gs-post-excerpt" v-text="post.preview"></div>
                <div class="gs-box-footer">
                    <div class="gs-author">
                        <img :src="post.author.src" alt="">
                        <span class="ps-author-first-name" v-text="post.expositor.first_name"></span>
                        <span class="ps-author-last-name" v-text="post.expositor.last_name"></span>
                    </div>
                    <div class="gs-box-post-date" v-text="post.date"></div>
                </div>
            </div>
        </v-card-text>
        <div class="gs-footer-post-footer">
            <div class="gs-hr"></div>
            <v-card-actions>
                <v-btn icon>
                    <v-icon size="15" color="#acacac">mdi-camcorder</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon size="15" color="#acacac">mdi-headphones</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon size="15" color="#acacac">mdi-cloud-download</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon size="15" color="#acacac">mdi-share-variant</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>

<script>

    import {VApp, VCard, VImg, VRow, VProgressCircular, VCardText, VCardActions, VBtn, VIcon, VSpacer} from 'vuetify/lib'

    export default {
        props: {
            post: Object
        },
        components: {
            VCard, VImg, VRow, VProgressCircular, VCardText, VCardActions, VBtn, VIcon, VSpacer
        },
        methods: {
            goToPost: function ( url ) {
                document.location.href = url;
            },
        }
    }
</script>

<style lang="scss">

    .gs-post-card {

        padding-bottom: 50px;
        max-width: 295px!important;
        margin: 5px;
        min-height: 472px;

        &.xs {
            max-width: 100% !important;
            margin: 20px;
            margin-top: 9px;
            margin-bottom: 12px;
        }

        &:hover {
            background: rgba(0, 139, 255, 0.06);
            cursor: pointer;
            .v-image, img {
                opacity: 0.8;
            }
        }

        .gs-post-data {
            position: relative;
            .categories {
                ul {
                    padding-left: 0px!important;
                }
            }
        }

        .v-card__text {
            padding: 6px 11px 11px 11px;
        }
        ul {
            padding-left: 0;
            li.gs-category-li {
                &:first-child {
                    margin-left: 0px;
                }
                list-style: none;
                border-radius: 10px;
                color: white;
                font-size: 10px;
                line-height: 12px;
                display: inline-block;
                margin-right: 10px;
                margin-top: 5px;
                background: #c7c7c7;
                padding: 1px 6px;
            }
        }

        .gs-post-title {
            font-family: "Montserrat", sans-serif;
            font-size: 13px;
            font-weight: bold;
            line-height: 16px;
            color: #4d4d4d;
            margin-top: 13px;
            margin-bottom: 13px;
        }

        .gs-post-excerpt {
            font-size: 11px;
            line-height: 16px;
        }

        .gs-box-footer {
            height: 50px;
            position: relative;
            padding-left: 48px;
            margin-bottom: 6px;
            img {
                position: absolute;
                left: 0;
                top: 7px;
                width: 40px;
                border-radius: 100%;
            }
            .gs-author {
                font-size: 11px;
                padding-top: 10px;
                font-family: "Montserrat", sans-serif;
                .ps-author-first-name {
                    font-style: italic;
                }
                .ps-author-last-name {
                    font-weight: bold;
                    font-style: italic;
                    margin-left: 3px;
                    color: #555555;
                }
            }
        }
        .gs-box-post-date {
            font-size: 11px;
            font-style: italic;
            float: right;
            margin-right: 10px;
            color: #319df5;
        }

        .gs-footer-post-footer {

            padding: 0 13px 0 13px;

            button {
                background: none;
            }
            .gs-hr {
                width: 100%;
                padding: 17px;
                height: 1px;
                background: #e3e3e3;
                padding: 10px;
            }
        }

    }
</style>
